var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-apply-1903010 1",
    clipPath: "url(#clip0_24_7283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.4754 19.8066C27.586 19.8066 24.4529 22.9397 24.4529 26.8291C24.4526 30.7185 27.6218 33.8517 31.4754 33.8517C35.329 33.8517 38.4979 30.7186 38.4979 26.8291C38.4979 22.9397 35.3648 19.8066 31.4754 19.8066ZM35.3286 26.1089L31.1151 30.3224C30.611 30.8266 29.8187 30.8266 29.3145 30.3224L27.6578 28.6657C27.1536 28.1615 27.1536 27.3692 27.6578 26.865C28.1619 26.3609 28.9542 26.3609 29.4584 26.865L30.2148 27.6214L33.528 24.3082C34.0322 23.8041 34.8245 23.8041 35.3286 24.3082C35.8328 24.8124 35.8328 25.6047 35.3286 26.1089Z",
    fill: "#268A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6523 26.8296C22.6523 21.968 26.6138 18.0065 31.4754 18.0065H32.9517V1.83669C32.9517 1.00845 32.3036 0.360352 31.4754 0.360352H7.95901C7.16673 0.360352 6.48242 1.00845 6.48242 1.83669V34.1762C6.48242 35.0044 7.13052 35.6528 7.95901 35.6528H31.4754C26.6135 35.6528 22.6523 31.6915 22.6523 26.8296ZM16.242 25.137H13.0728C12.2445 25.137 11.5962 24.4889 11.5962 23.6604C11.5962 22.8322 12.2443 22.1838 13.0728 22.1838H16.242C17.0702 22.1838 17.7186 22.8319 17.7186 23.6604C17.7186 24.4889 17.0705 25.137 16.242 25.137ZM19.3753 17.3582H13.073C12.2448 17.3582 11.5964 16.7101 11.5964 15.8816C11.5964 15.0534 12.2445 14.405 13.073 14.405H19.3393C20.1676 14.405 20.8159 15.0531 20.8159 15.8816C20.8157 16.7099 20.1676 17.3582 19.3753 17.3582ZM13.073 9.57945C12.2448 9.57945 11.5964 8.93134 11.5964 8.10286C11.5964 7.27462 12.2445 6.62626 13.073 6.62626H22.2923C23.1206 6.62626 23.7689 7.27437 23.7689 8.10286C23.7689 8.93109 23.1208 9.57945 22.2923 9.57945H13.073Z",
    fill: "#268A66"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_7283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 39.1157,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.b879e10dfc4981b62d0baddec8c94375.svg";
export { ForwardRef as ReactComponent };